// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import type { Project } from '@evolvemep/api-ts';

import { GridMenu } from 'components/Mantine/GridMenu';
import { isNil } from 'helpers/isNotNil';

type Props = {
  project: Project;
  selectProject: (project: Project) => void;
  statusChangeProject: (project: Project) => void;
  deleteProject: (project: Project) => void;
};

export const EditProjectMenu = ({ project, selectProject, statusChangeProject, deleteProject }: Props) => (
  <GridMenu
    options={[
      {
        value: 'Select project',
        hidden: project.isClosed || isNil(selectProject),
      },
      {
        label: `${project.isClosed ? 'Activate' : 'Archive'} project`,
        value: 'open-close-project',
      },
      {
        value: 'Delete',
      },
    ]}
    onMenuItemSelected={(selectedMenuOption) => {
      switch (selectedMenuOption) {
        case 'Select project':
          selectProject(project);
          break;
        case 'open-close-project':
          statusChangeProject(project);
          break;
        case 'Delete':
          deleteProject(project);
          break;
      }
    }}
  />
);
